/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validate;
function validate(region) {
  var isValid = true;
  if (region.right < region.left) {
    isValid = false;
    region.right = region.left;
  }
  if (region.bottom < region.top) {
    isValid = false;
    region.bottom = region.top;
  }
  return isValid;
}